export enum ReleaseMilestone {
    Kickoff = 'kickoff',
    BuildAvailable = 'buildAvailable',
    Submission = 'submission',
    SubmissionApproved = 'submissionApproved',
    ReleaseCompleted = 'releaseCompleted',
}

export const releaseMilestoneLabels: Record<ReleaseMilestone, string> = {
    [ReleaseMilestone.Kickoff]: 'Kickoff',
    [ReleaseMilestone.BuildAvailable]: 'Build available for testing',
    [ReleaseMilestone.Submission]: 'Submission',
    [ReleaseMilestone.SubmissionApproved]: 'Submission approved',
    [ReleaseMilestone.ReleaseCompleted]: 'Release completed',
};

export const allReleaseMilestones: ReleaseMilestone[] = [
    ReleaseMilestone.Kickoff,
    ReleaseMilestone.BuildAvailable,
    ReleaseMilestone.Submission,
    ReleaseMilestone.SubmissionApproved,
    ReleaseMilestone.ReleaseCompleted,
];

export type VCSDirectPushBranchTarget = 'workingBranch' | 'releaseBranch';

export interface VCSDirectPushCheckRequest {
    orgId: string;
    appId: string;
    branchTarget: VCSDirectPushBranchTarget;
    createsMergeCommit: boolean;
    canWaitForRequiredStatusChecks: boolean;
}

export type VCSDirectPushPrerequisiteStatus = 'passed' | 'warning' | 'blocked';

export interface VCSDirectPushPolicyReference {
    label: string;
    url?: string;
}

export interface VCSDirectPushPrerequisite {
    name: string;
    status: VCSDirectPushPrerequisiteStatus;
    policy?: VCSDirectPushPolicyReference;
    explanation?: string;
}

export interface VCSDirectPushCheckResult {
    branch: string;
    branchLabel: string;
    status: VCSDirectPushPrerequisiteStatus;
    prerequisites: VCSDirectPushPrerequisite[];
}

export interface VCSDirectPushCheckResponse {
    available: boolean;
    unavailableReason?: string;
    result?: VCSDirectPushCheckResult;
}

export interface BypassPullRequestsAutomationData {
    shouldCommitAndPushDirectlyToTargetBranch?: boolean;
}
